import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { TotalPromotionalChargesResponse } from 'api/ControllingApi';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

export async function getTotalPromotionalCredits(axios: AxiosInstance): Promise<TotalPromotionalChargesResponse> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/controlling/promotional-credits`);
  return data;
}

export default function useTotalPromotionalCreditsQuery() {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(),
    queryFn: () => getTotalPromotionalCredits(axios),
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey() {
  return ['TotalPromotionalCredits'] as const satisfies QueryKey;
}
useTotalPromotionalCreditsQuery.getKey = getKey;
